import axios from "axios";
import React, { useEffect, useState } from "react";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { Plus, Dash } from "react-bootstrap-icons";

export default function CreateClassModal({ id, cancelModal, fetchData }) {
  //styled
  const [name, setName] = useState("");
  const [nameErr, setNameErr] = useState("");
  const [description, setDescription] = useState("");
  const [descriptionErr, setDescriptionErr] = useState("");
  const [day, setDay] = useState("Monday");
  const [timeIn, setTimeIn] = useState("");
  const [timeInErr, setTimeInErr] = useState("");
  const [timeOut, setTimeOut] = useState("");
  const [timeOutErr, setTimeOutErr] = useState("");
  const [oneOff, setOneOff] = useState(false);
  const [oneOffDate, setOneOffDate] = useState(null);
  const [products, setProducts] = useState([]);
  const [recurringProducts, setRecurringProducts] = useState([]);
  const [totalAccessProducts, setTotalAccessProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [complete, setComplete] = useState(false);
  const [checkConfirm, setCheckConfirm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [price, setPrice] = useState(null);
  const [priceErr, setPriceErr] = useState(null);
  const [additionalDays, setAdditionalDays] = useState([]);
  const [addAdditionalDays, setAddAdditionalDays] = useState(false);
  const [additionalDay, setAdditionalDay] = useState("Monday");
  const [additionaltimeIn, setAdditionalTimeIn] = useState("");
  const [additionaltimeInErr, setAdditionalTimeInErr] = useState("");
  const [additionaltimeOut, setAdditionalTimeOut] = useState("");
  const [additionaltimeOutErr, setAdditionalTimeOutErr] = useState("");
  const [bookingCapacity, setBookingCapacity] = useState(0);
  const nameRegex = /^[a-zA-Z0-9 ]+$/;

  const { user } = useAuthContext();

  const handlePriceChange = (e) => {
    const value = e.target.value ? parseFloat(e.target.value) : null;
    setPrice(value);
  };

  const handleCheckboxChange = (event) => {
    const productId = parseInt(event.target.value);
    const eventId = null;
    if (event.target.checked) {
      setSelectedProducts([...selectedProducts, { productId, eventId }]);
    } else {
      setSelectedProducts(
        selectedProducts.filter((item) => item.productId !== productId)
      );
    }
  };

  const filterRecurringProducts = () => {
    return products.filter((product) => product.totalAccess === false);
  };

  const filterTotalAccessProducts = () => {
    return products.filter((product) => product.totalAccess === true);
  };

  useEffect(() => {
    const recurringProducts = filterRecurringProducts();
    const totalAccessProducts = filterTotalAccessProducts();

    setRecurringProducts(recurringProducts);
    setTotalAccessProducts(totalAccessProducts);
  }, [products, user]);

  useEffect(() => {
    const fetchData = async () => {
      const productResponse = await axios.get(
        `${ApiConnectionString}/api/myProducts?ClubId=${id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      setProducts(productResponse.data);
    };
    fetchData();
  }, [user]);

  useEffect(() => {
    if (!oneOff) {
      setOneOffDate(null);
    } else if (oneOff && oneOffDate) {
      const daysOfWeek = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];

      const selectedDate = new Date(oneOffDate);
      const dayIndex = selectedDate.getDay();
      const dayName = daysOfWeek[dayIndex];

      setDay(dayName);
    }
  }, [oneOff, oneOffDate, user]);

  const convertTimeToInt = (time) => {
    return parseInt(time.replace(":", ""), 10);
  };

  const handleConfirm = async (e) => {
    e.preventDefault();

    const createEvent = {
      clubId: parseInt(id),
      name,
      description,
      day,
      timeIn: convertTimeToInt(timeIn),
      timeOut: convertTimeToInt(timeOut),
      oneOff,
      oneOffDate,
      createProductAccesses: selectedProducts,
      price: price * 100,
      additionalDays,
      bookingCapacity,
    };

    try {
      const createEventResponse = await axios.post(
        `${ApiConnectionString}/api/event`,
        createEvent,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      if (createEventResponse.status === 200) {
        setCheckConfirm(false);
        setComplete(true);
      }
    } catch (error) {
      console.error("Error creating event:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setNameErr("");
    setDescriptionErr("");
    setTimeInErr("");
    setTimeOutErr("");
    let error = false;

    //price Validation
    if (price > 50) {
      error = true;
      setPriceErr("The price must not exceed £50");
    } else if (price > 0 && price < 1) {
      error = true;
      setPriceErr("The price must be at least £1");
    }

    //Name Validations
    if (name.length > 60) {
      error = true;
      setNameErr("Name is too long");
    }
    if (!nameRegex.test(name)) {
      error = true;
      setNameErr("The Name can only include letters, spaces");
    }
    //Description Validations
    if (name.description > 3000) {
      error = true;
      setDescriptionErr("Name is too long");
    }
    //TimeIn Validation
    if (timeIn > timeOut) {
      error = true;
      setTimeInErr("Time in must not be greater than the time out");
    }
    if (timeIn == "") {
      error = true;
      setTimeInErr("Time in required");
    }
    if (timeOut == "") {
      error = true;
      setTimeOutErr("Time out required");
    }

    if (!error) {
      setCheckConfirm(true);
    }
  };

  const AddAdditioalDayFunk = () => {
    let error = false;
    setAdditionalTimeInErr("");
    setAdditionalTimeOutErr("");
    if (additionaltimeIn > additionaltimeOut) {
      error = true;
      setAdditionalTimeOutErr("Time in must not be greater than the time out");
    }
    if (additionaltimeIn == "") {
      error = true;
      setAdditionalTimeInErr("Time in is required");
    }
    if (additionaltimeOut == "") {
      error = true;
      setAdditionalTimeOutErr("Time out is required");
    }
    if (!error) {
      const newDay = {
        day: additionalDay,
        timeIn: convertTimeToInt(additionaltimeIn),
        timeOut: convertTimeToInt(additionaltimeOut),
      };

      setAdditionalDays([...additionalDays, newDay]);

      // Optionally reset the input fields after adding
      setAdditionalDay("Monday");
      setAdditionalTimeIn("");
      setAdditionalTimeOut("");
    }
  };
  const removeDay = (indexToRemove) => {
    setAdditionalDays(
      additionalDays.filter((_, index) => index !== indexToRemove)
    );
  };

  if (isLoading) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <LoadingSpinner />
        </div>
      </div>
    );
  } else {
    if (checkConfirm) {
return (
  <div className="fullscreen-modal-overlay">
    <div className="fullscreen-modal p-4">
      <div className="blueBanner mb-3">
        <p className="fw-bold m-0 p-2 fs-4">Confirm</p>
      </div>

      <div className="mb-4">
        <h5 className="fw-bold">{name}</h5>
        <p className="text-muted mb-1">{description}</p>
        <div className="border rounded p-3 mb-2 bg-light">
          <p className="mb-1"><strong>Day:</strong> {day}</p>
          <p className="mb-1"><strong>Time In:</strong> {timeIn}</p>
          <p className="mb-0"><strong>Time Out:</strong> {timeOut}</p>
        </div>

        {additionalDays && additionalDays.length > 0 && (
          <div className="">
        
            {additionalDays.map((item, index) => (
              <div
                key={index}
                className="border rounded p-3 mb-2 bg-white shadow-sm"
              >
                <p className="mb-1"><strong>Day:</strong> {item.day}</p>
                <p className="mb-1"><strong>Time In:</strong> {item.timeIn}</p>
                <p className="mb-0"><strong>Time Out:</strong> {item.timeOut}</p>
              </div>
            ))}
          </div>
        )}
      </div>

      <p className="mb-4">Please confirm that you are happy to create these classe(s).</p>

      <div className="send-modal-footer d-flex justify-content-end">
        <button
                className="saveChanges-button mx-3"
                onClick={handleConfirm}
              >
                Confirm
              </button>
              <button
                className="pointer cancelButton fw-bold mx-2 px-3"
                onClick={() => setCheckConfirm(false)}
              >
                Cancel
              </button>
      </div>
    </div>
  </div>
);

    } else if (complete) {
      return (
        <div className="fullscreen-modal-overlay">
          <div className="fullscreen-modal">
            <div className="blueBanner">
              <p className="fw-bold m-2 p-2 fontSize20">Classes Created</p>
            </div>

            <p>Classes have been created successfully.</p>
            <div className="send-modal-footer">
              <button
                className="pointer cancelButton fw-bold mx-2 px-3"
                onClick={() => {
                  fetchData();
                  setComplete(false);
                  cancelModal();
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="fullscreen-modal-overlay">
          <div className="fullscreen-modal">
            <div className="container">
              <div className="blueBanner d-flex justify-content-between">
                <p className="fw-bold m-2 p-2 fontSize20">Create Class</p>
                <button
                  onClick={() => cancelModal()}
                  className="saveChanges-button"
                >
                  Go Back
                </button>
              </div>
              <div className="d-flex justify-content-end mt-0">
                <button
                  onClick={() => setOneOff(false)}
                  className="settings-menu-button"
                >
                  Routine Class
                </button>
                <button
                  onClick={() => setOneOff(true)}
                  className="settings-menu-button"
                >
                  One Off Class
                </button>
              </div>

              <div className="lightBlueBanner mt-3 mb-0">
                <p className="fw-bold p-2 mb-0">
                  {oneOff ? "One Off Class" : "Routine Class"}
                </p>
              </div>
              {oneOff ? (
                <p className="text-muted mt-0">
                  This class will occur only once on the selected date. To make
                  it a recurring weekly class, please press "Routine Class"
                  above.
                </p>
              ) : (
                <p className="text-muted mt-0">
                  This class is currently set to recur weekly. You can choose
                  the day, and it will take place on that day each week. To
                  change it to a one-time event, please press "One Off Class"
                  above.
                </p>
              )}

              <table>
                <tbody>
                  <tr>
                    <td className="red-text fw-bold">
                      <label htmlFor="name">Class Name:</label>
                    </td>
                    <td>
                      <input
                        type="text"
                        id="name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                      />
                      {nameErr && <p className="text-danger">{nameErr}</p>}
                    </td>
                  </tr>
                  <tr>
                    <td className="red-text fw-bold">
                      <label htmlFor="description">Subtitle:</label>
                    </td>
                    <td>
                      <textarea
                        id="description"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        required
                      />
                      {descriptionErr && (
                        <p className="text-danger">{descriptionErr}</p>
                      )}
                      <p className="text-muted">
                        For example, "All levels and abilities"
                      </p>
                    </td>
                  </tr>

                  <tr>
                    <td className="red-text fw-bold">
                      <label htmlFor="timeIn">Time In:</label>
                    </td>
                    <td>
                      <input
                        type="time"
                        id="timeIn"
                        value={timeIn}
                        onChange={(e) => setTimeIn(e.target.value)}
                        required
                      />
                      {timeInErr && <p className="text-danger">{timeInErr}</p>}
                    </td>
                  </tr>
                  <tr>
                    <td className="red-text fw-bold">
                      <label htmlFor="timeOut">Time Out:</label>
                    </td>
                    <td>
                      <input
                        type="time"
                        id="timeOut"
                        value={timeOut}
                        onChange={(e) => setTimeOut(e.target.value)}
                        required
                      />
                      {timeOutErr && (
                        <p className="text-danger">{timeOutErr}</p>
                      )}
                    </td>
                  </tr>
                  {!oneOff && (
                    <tr>
                      <td className="red-text fw-bold">
                        <label htmlFor="day">Day:</label>
                      </td>
                      <td>
                        <select
                          id="day"
                          value={day}
                          onChange={(e) => setDay(e.target.value)}
                          required
                        >
                          <option value="Monday">Monday</option>
                          <option value="Tuesday">Tuesday</option>
                          <option value="Wednesday">Wednesday</option>
                          <option value="Thursday">Thursday</option>
                          <option value="Friday">Friday</option>
                          <option value="Saturday">Saturday</option>
                          <option value="Sunday">Sunday</option>
                        </select>
                      </td>
                    </tr>
                  )}

                  {oneOff && (
                    <tr>
                      <td>
                        <label
                          className="red-text fw-bold"
                          htmlFor="oneOffDate"
                        >
                          Date:
                        </label>
                      </td>
                      <td>
                        <input
                          type="date"
                          id="oneOffDate"
                          value={oneOffDate}
                          onChange={(e) => setOneOffDate(e.target.value)}
                          required
                        />
                      </td>
                    </tr>
                  )}

                  <tr>
                    <td className="red-text fw-bold">
                      <label htmlFor="price">Class Capacity: </label>
                    </td>
                    <td>
                      <input
                        type="number"
                        id="classLimit"
                        name="classLimit"
                        pattern="^\d*$"
                        inputMode="numeric"
                        value={bookingCapacity}
                        onChange={(e) => {
                          const value = e.target.value;
                          // Optionally validate the value or ignore invalid input
                          if (/^\d*$/.test(value)) {
                            setBookingCapacity(value);
                          }
                        }}
                      />
                      <p className="text-muted">
                        How many people can attend this at one time? If there is
                        no limit, leave it as zero.
                      </p>
                    </td>
                  </tr>

                  <tr>
                    <td className="red-text fw-bold">
                      <label htmlFor="price">Price (£): </label>
                    </td>
                    <td>
                      <input
                        className=""
                        type="number"
                        id="price"
                        step="0.01"
                        value={price === null ? "" : price}
                        onChange={handlePriceChange}
                        placeholder="Enter price"
                      />
                    </td>
                  </tr>
                  {priceErr && <p className="text-danger">{priceErr}</p>}
                </tbody>
              </table>
              <p className="text-muted">
                The price is the cost for a customer to book this class as a
                one-time purchase, without a subscription or class tokens. If
                you do not want to offer this option, leave this field blank.
              </p>

              <hr></hr>

              {!oneOff && (
                <div>
                  {additionalDays.length > 0 && (
                    <div className="additional-classes-section mt-4">
                      <h5 className="section-heading mb-3">
                        Additional Classes
                      </h5>
                      {additionalDays.map((day, index) => (
                        <div
                          key={index}
                          className="additional-class-card d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-2 mb-2"
                        >
                          <div>
                            <div>
                              <strong>Day:</strong> {day.day}
                            </div>
                            <div>
                              <strong>Time In:</strong> {day.timeIn}
                            </div>
                            <div>
                              <strong>Time Out:</strong> {day.timeOut}
                            </div>
                          </div>
                          <button
                            type="button"
                            onClick={() => removeDay(index)}
                            className="profile-blue-button d-flex align-items-center"
                          >
                            <Dash className="profile-social-icon" />
                            <span className="fw-bold text-white mx-2">
                              Remove
                            </span>
                          </button>
                        </div>
                      ))}
                    </div>
                  )}

                  {addAdditionalDays && (
                    <div className="border">
                      <div>
                        <label htmlFor="timeIn">Time In:</label>
                        <input
                          type="time"
                          id="timeIn"
                          value={additionaltimeIn}
                          onChange={(e) => setAdditionalTimeIn(e.target.value)}
                          required
                        />
                        {timeInErr && (
                          <p className="text-danger">{timeInErr}</p>
                        )}
                      </div>
                      <div>
                        <label htmlFor="timeOut">Time Out:</label>
                        <input
                          type="time"
                          id="timeOut"
                          value={additionaltimeOut}
                          onChange={(e) => setAdditionalTimeOut(e.target.value)}
                          required
                        />
                        {additionaltimeOutErr && (
                          <p className="text-danger">{additionaltimeOutErr}</p>
                        )}
                      </div>
                      <label htmlFor="day">Day:</label>
                      <select
                        id="day"
                        value={additionalDay}
                        onChange={(e) => setAdditionalDay(e.target.value)}
                        required
                      >
                        <option value="Monday">Monday</option>
                        <option value="Tuesday">Tuesday</option>
                        <option value="Wednesday">Wednesday</option>
                        <option value="Thursday">Thursday</option>
                        <option value="Friday">Friday</option>
                        <option value="Saturday">Saturday</option>
                        <option value="Sunday">Sunday</option>
                      </select>

                      <div className="d-flex justify-content-between">
                        <button
                          onClick={AddAdditioalDayFunk}
                          className="profile-blue-button mb-2 d-flex"
                        >
                          <Plus className="profile-social-icon" />{" "}
                          <a className="fw-bold mx-2 mt-1">
                            Add Additional Class
                          </a>
                        </button>
                        <button
                          className="pointer cancelButton fw-bold mx-2 px-3"
                          onClick={(e) => {
                            e.preventDefault();
                            setAddAdditionalDays(false);
                          }}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  )}
                  {!addAdditionalDays && (
                    <p>
                      If you want to duplicate this class on additional days and
                      times, please press "Add an Additional Class" below.
                    </p>
                  )}

                  {!addAdditionalDays ? (
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        setAddAdditionalDays(true);
                      }}
                      className="profile-blue-button mb-2 d-flex"
                    >
                      <Plus className="profile-social-icon" />{" "}
                      <a className="fw-bold mx-2 mt-1">
                        Add An Additional Class
                      </a>
                    </button>
                  ) : (
                    <div></div>
                  )}
                </div>
              )}

              {recurringProducts.length != 0 && (
                <div>
                  <div className="lightBlueBanner">
                    <p className="fw-bold p-2 mb-0">Grant Access</p>
                  </div>

                  <p className="mt-0 text-muted">
                    Your payment subscriptions and class tokens are listed
                    below. To grant access using a payment option, check the box
                    next to its name. Please note that payment options granting
                    access to all classes are not listed, as they already
                    provide access.
                  </p>
                  {recurringProducts.map((product) => (
                    <div key={product.id}>
                      <input
                        type="checkbox"
                        value={product.id}
                        onChange={handleCheckboxChange}
                        checked={selectedProducts.some(
                          (item) => item.productId === product.id
                        )}
                        className="mx-2"
                      />
                      {product.name}
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="send-modal-footer">
              <button className="saveChanges-button " onClick={handleSubmit}>
                Create Class
              </button>
              <button
                onClick={cancelModal}
                className="pointer cancelButton fw-bold mx-2 px-3"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      );
    }
  }
}
